module.exports = __webpack_public_path__ + "static/media/bbcnews.7b12dd56.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/bbcnews.png
// module id = 519
// module chunks = 0